import { Box, Typography } from "@mui/material";
import new_checkIcon from "../assets/images/new_check.svg";
import { fontSizeSchemes } from "../assets/commonFunction";
const RecommendedBox = ({ content,fontSize = fontSizeSchemes.font12,tickIconStyle,ml = 0,fontWeight = 400}) => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.4rem",
        border: "1px solid #000000",
        borderRadius: "3rem",
        padding: "0rem 0.8rem 0rem 0.7rem",
        ml:ml
      }}
    >
      <Box sx={{display: "inline-flex",
        alignItems: "center",}}>
        <img style={tickIconStyle} src={new_checkIcon} alt="" />
      </Box>
      <Typography fontSize={fontSize} fontWeight={400} variant="caption">{content}</Typography>
    </Box>
  );
};

export default RecommendedBox;
